<template>
  <div class="field-checkbox">
    <InputSwitch
      v-if="inputSwitch"
      :id="name"
      v-model="inputValue"
      :name="name"
      :value="value"
      :binary="true"
      :disabled="disabled"
      true-value="1"
      false-value="0"
      @click="onClick"
    />
    <Checkbox v-else v-model="inputValue" :value="value" @input="onClick" />
    {{ trueValue }}
    <label v-if="label" :for="name">
      <i class="pi" :class="icon" />
      {{ label }}
    </label>
  </div>
</template>

<script>
import { useField } from "vee-validate";
import { ref, watch } from "vue";
export default {
  props: {
    type: {
      type: String,
      default: "text",
    },
    modelValue: {
      type: [String, Number],
      default: "",
    },
    value: {
      type: [String, Number, Boolean],
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    successMessage: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    className: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    inputSwitch: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const checked = ref("yes");
    const {
      value: inputValue,
      handleChange,
      errorMessage,
      meta,
    } = useField(props.name, props.rules, {
      // 👇 These are important
      type: "checkbox",
      initialValue: props.modelValue,
    });

    // watch(
    //   () => props.modelValue,
    //   (first) => {
    //     inputValue.value = first;
    //   }
    // );

    return {
      handleChange,
      errorMessage,
      inputValue,
      meta,
      checked,
    };
  },

  created() {
    // this.onClick();
  },
  methods: {
    onClick(event) {
      this.$emit("update:modelValue", this.inputValue);
      // this.$emit("change", event);
      // this.$emit("update:modelValue", this.inputValue ? 1 : 0);
    },
  },
};
</script>

<style scoped>
.TextInput {
  position: relative;

  width: 100%;
}

input:focus {
  border-color: var(--p-primary-color);
}
</style>
